import { KnowledgeList } from '~/components/knowledge/KnowledgeTimeline';
import type { KnowledgeEntry, TaskDetail } from '~/data/generated/model';
import { usePropertyKnowledge } from '~/data/hooks/useKnowledge';

/** A task with elevators sees their entries and the property-wide ones; a property-wide task sees everything. */
export function taskKnowledgeEntries(
  entries: readonly KnowledgeEntry[],
  task: Pick<TaskDetail, 'cars'>,
): KnowledgeEntry[] {
  if (task.cars.length === 0) return [...entries];
  const carIds = new Set(task.cars.map((car) => car.id));
  return entries.filter((entry) => !entry.carId || carIds.has(entry.carId));
}

export function TaskKnowledgeTab({ task }: { task: TaskDetail }) {
  const { entries, isLoading, error } = usePropertyKnowledge(task.propertyId);
  const shown = taskKnowledgeEntries(entries, task);

  return (
    <KnowledgeList
      propertyId={task.propertyId}
      entries={shown}
      isLoading={isLoading}
      error={error}
      description={
        task.cars.length
          ? "What the team knows about this task's elevators and the property."
          : 'What the team knows about this property.'
      }
      emptyMessage="No knowledge recorded here yet. Publish from the AI summary to add what the team should remember."
    />
  );
}
